import styled from 'styled-components';
import {  MdRemoveRedEye } from 'react-icons/md';
import LoadingOverlay from 'react-loading-overlay';
import { GiMoneyStack } from 'react-icons/gi';

export const Container = styled.div``;

export const WrapperTable = styled.div`
  padding: 20px 0;
`;

export const WrapperAdd = styled.div`
  width: 95%;
  margin-top: 25px;
  margin-bottom: 25px;
  display: flex;
  justify-content: flex-end;
`;

export const Loading = styled(LoadingOverlay).attrs({
  color: '#122d58',
  styles: {
    overlay: (base) => ({
      ...base,
      '& svg circle': {
        stroke: '#fff'
      },
      marginTop: '8%',
      height:'80%',
      color:'#fff',
      fontSize: 13,
      backgroundColor: '#122d58',
      opacity: 0.6,
      fontWeight: 600,
    }),
    fontWeight: 600
  }
})``;

export const IconReceive = styled(GiMoneyStack).attrs({
  size: '28px',
})`
  color: #7b7b7b;
  cursor: pointer;
  vertical-align:'center';
`;

export const EyeIcon = styled(MdRemoveRedEye).attrs({ size: '19px' })`
  color: #122d58;
  cursor: pointer;
  margin-right: 26px;
`;

